import { BaseModel } from 'app/core/_base/crud';
import { FileImport } from '../../../dung-chung/__model/file-import.model';
export class SettingYCXK extends BaseModel {
    static optionsTrangThai = [
        {
            Position : 1,
            Code : "YCXK_CHODUYET",
            Value : "Chờ duyệt",
            Show: true,
        },
        {
            Position : 2,
            Code : "YCXK_DAXACNHAN",
            Value : "Đã xác nhận",
            Show: true
        },
        {
            Position : 3,
            Code : "YCXK_DANHAPKETQUA",
            Value : "Đã nhập kết quả",
            Show: true
        },
        {
            Position : 4,
            Code : "YCXK_DADUYET",
            Value : "Đã duyệt",
            Show: true
        },
        {
            Position : 5,
            Code : "YCXK_DAXOA",
            Value : "Đã xoá",
            Show: true
        }
    ];

    static pk_status = [
        {
            id: 1,
            name: 'Đang soạn thảo',
            value: 'PK_DST',
            show: true
        },
        {
            id: 2,
            name: 'Chờ TP',
            value: 'PK_WTP',
            show: true
        },
        {
            id: 3,
            name: 'Chờ QA Lab',
            value: 'PK_WQALAD',
            show: true
        },
        {
            id: 4,
            name: 'Chờ QA Process',
            value: 'PK_WQAPROCESS',
            show: true
        },
        {
            id: 5,
            name: 'Chờ TP Operation',
            value: 'PK_WTPO',
            show: true
        },
        {
            id: 6,
            name: 'Hoàn tất',
            value: 'PK_HT',
            show: true
        },
        {
            id: 7,
            name: 'Đã hủy',
            value: 'PK_H',
            show: true
        },
        {
            id: 8,
            name: 'Đã xóa',
            value: 'PK_X',
            show: false
        },
        {
            id: 9,
            name: 'Không duyệt',
            value: 'PK_KD',
            show: true
        }
    ];
    
    static type_of_mer = [
        {
            code: "Bán thành phẩm",
            value: "5"
        },
        // {
        //     code: "Nguyên phụ liệu, báo chí",
        //     value: "1,2,6"
        // },
        {
            code: "Thành phẩm",
            value: "4"
        }
    ];

    static BTN_STPKH = "Lưu và Gửi tp kế hoạch duyệt";
    static BTN_STP = "Lưu và Gửi tp duyệt";
    static BTN_SQALAB = "Lưu kết quả TP duyệt";
    static BTN_SQAPROCESS = "Lưu và Gửi cho QA Process";
    static BTN_STPO = "Lưu kết quả QA Process duyệt";
    static BTN_SHT = "Lưu kết quả TP Operation duyệt";
}

export class YeuCauXuatKhanModel extends BaseModel {
    Id : number
    BoPhanYeuCauId : number
    BoPhanYeuCauName: string
    SoPhieu : string
    TinhTrang : string
    TinhTrang_Code : string
    NgayDeNghi : string
    NguoiDeNghi : number
    ThoiGianTao : string
    NguoiTao : number
    TinhTrangHangDNXK : number
    GhiChuLyDo : string
    KetQuaKiemTraChatLuong : string
    YKien : string
    TenNguoiTao: string
    TenNguoiDeNghi: string
    Cts : YeuCauXuatKhan_CtModel[]
    CoQuyenDuyet: boolean
    color: string
    clear() {
            this.Id = 0;
            this.BoPhanYeuCauId = 0;
            this.SoPhieu = '';
            this.TinhTrang = '';
            this.TinhTrang_Code = '';
            this.GhiChuLyDo = '';
            this.NgayDeNghi = new Date().toISOString();
            this.NguoiDeNghi = 0;
            this.ThoiGianTao = new Date().toISOString();
            this.NguoiTao = 0;
            this.TinhTrangHangDNXK = 0;
            this.KetQuaKiemTraChatLuong = '';
            this.YKien = '';
            this.Cts = [];
            this.TenNguoiTao = '';
            this.TenNguoiDeNghi = ''
            this.CoQuyenDuyet = false;
            this.BoPhanYeuCauName ="";
            this.color = "";
    }
    copy(item:YeuCauXuatKhanModel){
            this.Id = item.Id;
            this.BoPhanYeuCauId = item.BoPhanYeuCauId;
            this.SoPhieu = item.SoPhieu;
            this.TinhTrang = item.TinhTrang;
            this.GhiChuLyDo = item.GhiChuLyDo;
            this.NgayDeNghi = item.NgayDeNghi;
            this.NguoiDeNghi = item.NguoiDeNghi;
            this.ThoiGianTao = item.ThoiGianTao;
            this.NguoiTao = item.NguoiTao;
            this.TinhTrangHangDNXK = item.TinhTrangHangDNXK;
            this.KetQuaKiemTraChatLuong = item.KetQuaKiemTraChatLuong;
            this.YKien = item.YKien;
            this.Cts = item.Cts;
            this.TenNguoiDeNghi = item.TenNguoiDeNghi;
            this.TenNguoiTao = item.TenNguoiTao;
            this.CoQuyenDuyet = item.CoQuyenDuyet;
            this.TinhTrang_Code = item.TinhTrang_Code;
            this.BoPhanYeuCauName = item.BoPhanYeuCauName;
            this.color = item.color;
    }
}
export class YeuCauXuatKhan_CtModel extends BaseModel {
    Id : number
    YeuCauXuatKhan_id : number
    HangHoaId : number
    HangHoaTen: string
    IdLo: number
    LotSX : string
    NgaySX : string
    NgayDeNghiPassKhan : string
    KhoiLuong : number
    KhoiLuongTon: number
    NguyenNhanXK : string
    GhiChuNguyenNhan : string
    IdHH: any;
    STT : number
    IdTk : number
    HangHoaMa : string
    IsChecked : boolean
    IsMain : boolean
    TongTonDaChon : number
    SoLuongCanXuat : number
    DeNghiXuatKho_Id : number
    DeNghiXuatKho_SoPhieu : string
    MaSub : string
    HanSuDung : string
    Dvt : number
    TenDvt : string
    Ncc : number
    TenNcc : string
    NgayNhan : string
    SoPhieuNK : string
    IdLoaiHH : number
    IdPKTPK : number
    ChoPhepXuatKho: boolean
    IdPKT : number
    KhoName: string
    machines: any[]
    id_level: number
    ma_may: string
    chi_tieu: any[]
    IsThanhPham: boolean
    IsBTP: boolean
    IsAnother: boolean
    khoi_luong: number
    clear() {
            this.Id = 0;
            this.YeuCauXuatKhan_id = 0;
            this.HangHoaId = 0;
            this.HangHoaTen = '';
            this.LotSX = '';
            this.IdLo = 0;
            this.NgaySX = new Date().toISOString();
            this.NgayDeNghiPassKhan = new Date().toISOString();
            this.KhoiLuong = 0;
            this.NguyenNhanXK = "";
            this.GhiChuNguyenNhan = '';
            this.STT = 0;
            this.IdTk = 0;
            this.HangHoaMa = ""
            this.IsChecked = false
            this.IsMain = false;
            this.TongTonDaChon = 0;
            this.SoLuongCanXuat = 0;
            this.DeNghiXuatKho_Id = 0;
            this.MaSub = "";
            this.HanSuDung = ""
            this.Dvt = 0
            this.TenDvt = ""
            this.Ncc = 0
            this.TenNcc = ""
            this.NgayNhan = ""
            this.SoPhieuNK = ""
            this.IdLoaiHH = 0
            this.IdPKTPK = 0
            this.ChoPhepXuatKho = null
            this.IdPKT = 0
            this.KhoiLuongTon = 0
            this.KhoName = "";
            this.DeNghiXuatKho_SoPhieu = "";
            this.machines = []
            this.id_level = 0
            this.ma_may = ""
            this.chi_tieu = []
            this.IsThanhPham = false;
            this.IsBTP = false;
            this.IsAnother = false;
            this.khoi_luong = 0
    }
    copy(item:YeuCauXuatKhan_CtModel){
            this.Id = item.Id;
            this.YeuCauXuatKhan_id = item.YeuCauXuatKhan_id;
            this.HangHoaId = item.HangHoaId;
            this.HangHoaTen = item.HangHoaTen;
            this.LotSX = item.LotSX;
            this.IdLo = item.IdLo;
            this.NgaySX = item.NgaySX;
            this.NgayDeNghiPassKhan = item.NgayDeNghiPassKhan;
            this.KhoiLuong = item.KhoiLuong;
            this.NguyenNhanXK = item.NguyenNhanXK;
            this.GhiChuNguyenNhan = item.GhiChuNguyenNhan;
            this.STT = item.STT;
            this.IdTk = item.IdTk;
            this.HangHoaMa = item.HangHoaMa
            this.IsChecked = item.IsChecked
            this.IsMain = item.IsMain;
            this.TongTonDaChon = item.TongTonDaChon;
            this.SoLuongCanXuat = item.SoLuongCanXuat;
            this.DeNghiXuatKho_Id = item.DeNghiXuatKho_Id;
            this.MaSub = item.MaSub;
            this.HanSuDung = item.HanSuDung;
            this.Dvt = item.Dvt;
            this.TenDvt = item.TenDvt;
            this.Ncc = item.Ncc;
            this.TenNcc = item.TenNcc;
            this.SoPhieuNK = item.SoPhieuNK;
            this.NgayNhan = item.NgayNhan;
            this.IdLoaiHH = item.IdLoaiHH;
            this.IdPKTPK = item.IdPKTPK
            this.ChoPhepXuatKho = item.ChoPhepXuatKho;
            this.IdPKT = item.IdPKT
            this.KhoiLuongTon = item.KhoiLuongTon;
            this.KhoName = item.KhoName;
            this.DeNghiXuatKho_SoPhieu = item.DeNghiXuatKho_SoPhieu;
            this.machines = item.machines
            this.id_level = item.id_level
            this.ma_may = item.ma_may
            this.chi_tieu = item.chi_tieu
            this.IsThanhPham = item.IsThanhPham;
            this.IsBTP = item.IsBTP;
            this.IsAnother = item.IsAnother;
            this.khoi_luong = item.khoi_luong
    }
}

export class PhieuKiemTraPassKhan extends BaseModel{
    static category_path_passkhan = "PKTPK";
    static DEFAULT_LOAIPHIEU = 1;
    static optionLoaiPhieu: any = [
            {
                id: 1,
                value: [1, 2, 3],
                name: 'nguyên phụ liệu - hóa chất'
            },
            {
                id: 2,
                value: [6],
                name: 'bao bì'
            },
            {
                id: 3,
                value: [4],
                name: 'thành phẩm'
            },
            {
                id: 4,
                value: [],
                name: 'khác'
            },
        ]
    Id: number
    Sophieu: string
    Loaiphieu: number
    Trangthai: string
    TenTrangThai: string
    HanghoaId: number
    MaHang: string
    TenHang: string
    IdLoai:number
    TenLoai: string
    QuyCach: string
    IdDVT: number
    TenDVT: string
    NccId: number
    MaNCC: string
    TenNCC: string
    KhachhangId: number
    TenKhachHang: string
    ThongtinhangveId: number
    IdLot: number
    Solosx: string
    Ngaysx: string
    Hansudung: string
    Hansudungtheothang: number
    Soluong: number
    SoluongDvt: number
    Ngaynhan: string
    Ngaysxlotruoc: string
    Thoigianbatdautiepnhan: string
    Thoigianketthuctiepnhan: string
    Ngaykiemtra: string
    Ngayphathanh: string
    Ghichu: string
    AttachmentId: number
    Quyetdinh: number
    Quyetdinhtext: string
    Chophepxuatkho: boolean
    Sodonvilaymau: string
    Soluongtra: number
    Soluongnhan: number
    SoluongtraNhanDvt: number
    Quyetdinhnhapkho: number
    Xulyphatsinhkph: boolean
    Thoigiantao: string
    Nguoitao: number
    TenNguoiTao: string
    Thoigiansua: string
    Nguoisua: number
    IdNKCT: number
    IdNK: number
    SoPhieuNK: string
    isDuyet: boolean
    lyDoDuyet: string
    listPhieuKiemTraKetQua: PhieuKiemTraPassKhanKetQua[]
    listPhieuKiemTraLsThaoTac: PhieuKiemTraLsPassKhanThaoTac[]
    listFileDinhKem: FileImport[]
    IdPassKhanCt: number

    clear(){
        this.Id = 0;
        this.Sophieu = '';
        this.Loaiphieu= 0;
        this.Trangthai= '';
        this.TenTrangThai = '';
        this.HanghoaId= 0;
        this.MaHang= '';
        this.TenHang= '';
        this.IdLoai = 0;
        this.TenLoai = '';
        this.QuyCach= '';
        this.IdDVT = 0;
        this.TenDVT = '';
        this.NccId= 0;
        this.MaNCC= '';
        this.TenNCC= '';
        this.KhachhangId= 0;
        this.TenKhachHang= '';
        this.ThongtinhangveId= 0;
        this.IdLot= 0;
        this.Solosx= '';
        this.Ngaysx= '';
        this.Hansudung= '';
        this.Hansudungtheothang= 0;
        this.Soluong= 0;
        this.SoluongDvt= 0;
        this.Ngaynhan= '';
        this.Ngaysxlotruoc= '';
        this.Thoigianbatdautiepnhan= '';
        this.Thoigianketthuctiepnhan= '';
        this.Ngaykiemtra= '';
        this.Ngayphathanh= '';
        this.Ghichu= '';
        this.AttachmentId= 0;
        this.Quyetdinh= 0;
        this.Quyetdinhtext= '';
        this.Chophepxuatkho = false;
        this.Sodonvilaymau= '';
        this.Soluongtra= 0;
        this.Soluongnhan= 0;
        this.SoluongtraNhanDvt= 0;
        this.Quyetdinhnhapkho= 0;
        this.Xulyphatsinhkph= false;
        this.Thoigiantao= '';
        this.Nguoitao= 0;
        this.TenNguoiTao= '';
        this.Thoigiansua= '';
        this.Nguoisua= 0;
        this.IdNKCT = 0;
        this.IdNK = 0;
        this.SoPhieuNK = '';
        this.isDuyet = false;
        this.lyDoDuyet = '';
        this.listPhieuKiemTraKetQua = [];
        this.listPhieuKiemTraLsThaoTac = [];
        this.listFileDinhKem = [];
        this.IdPassKhanCt = 0
    }
    copy(item: PhieuKiemTraPassKhan){
        this.Id = item.Id;
        this.Sophieu = item.Sophieu;
        this.Loaiphieu= item.Loaiphieu;
        this.Trangthai= item.Trangthai;
        this.TenTrangThai = item.TenTrangThai;
        this.HanghoaId= item.HanghoaId;
        this.MaHang= item.MaHang;
        this.TenHang= item.TenHang;
        this.IdLoai = item.IdLoai;
        this.TenLoai = item.TenLoai;
        this.QuyCach= item.QuyCach;
        this.IdDVT = item.IdDVT;
        this.TenDVT = item.TenDVT;
        this.NccId= item.NccId;
        this.MaNCC= item.MaNCC;
        this.TenNCC= item.TenNCC;
        this.KhachhangId= item.KhachhangId;
        this.TenKhachHang= item.TenKhachHang;
        this.ThongtinhangveId= item.ThongtinhangveId;
        this.IdLot= item.IdLot;
        this.Solosx= item.Solosx;
        this.Ngaysx= item.Ngaysx;
        this.Hansudung= item.Hansudung;
        this.Hansudungtheothang= item.Hansudungtheothang;
        this.Soluong= item.Soluong;
        this.SoluongDvt= item.SoluongDvt;
        this.Ngaynhan= item.Ngaynhan;
        this.Ngaysxlotruoc= item.Ngaysxlotruoc;
        this.Thoigianbatdautiepnhan= item.Thoigianbatdautiepnhan;
        this.Thoigianketthuctiepnhan= item.Thoigianketthuctiepnhan;
        this.Ngaykiemtra= item.Ngaykiemtra;
        this.Ngayphathanh= item.Ngayphathanh;
        this.Ghichu= item.Ghichu;
        this.AttachmentId= item.AttachmentId;
        this.Quyetdinh= item.Quyetdinh;
        this.Quyetdinhtext= item.Quyetdinhtext;
        this.Chophepxuatkho = item.Chophepxuatkho;
        this.Sodonvilaymau= item.Sodonvilaymau;
        this.Soluongtra= item.Soluongtra;
        this.Soluongnhan= item.Soluongnhan;
        this.SoluongtraNhanDvt= item.SoluongtraNhanDvt;
        this.Quyetdinhnhapkho= item.Quyetdinhnhapkho;
        this.Xulyphatsinhkph= item.Xulyphatsinhkph;
        this.Thoigiantao= item.Thoigiantao;
        this.Nguoitao= item.Nguoitao;
        this.TenNguoiTao= item.TenNguoiTao;
        this.Thoigiansua= item.Thoigiansua;
        this.Nguoisua= item.Nguoisua;
        this.IdNKCT = item.IdNKCT;
        this.IdNK = item.IdNK;
        this.SoPhieuNK = item.SoPhieuNK;
        this.isDuyet = item.isDuyet;
        this.lyDoDuyet = item.lyDoDuyet;
        this.listPhieuKiemTraKetQua = item.listPhieuKiemTraKetQua;
        this.listPhieuKiemTraLsThaoTac = item.listPhieuKiemTraLsThaoTac;
        this.listFileDinhKem = item.listFileDinhKem;
        this.IdPassKhanCt = item.IdPassKhanCt
    }
}

export class PhieuKiemTraPassKhanKetQua extends BaseModel{
    Id: number
    PhieukiemtraId: number
    MauphieukiemtraId: number
    MauphieukiemtraIdNhom: number
    MauphieukiemtraChitieuId: number
    TenNhomChiTieu: string
    TenChiTieu: string
    TieuChuan: string
    SoTieuChiTrongNhom: number
    Ketqua: string
    Danhgiaketqua: boolean
    Diengiai: string
    Thoigiandutru: string
    Danhgiaketquaselect: number

    clear(){
        this.Id = 0;
        this.PhieukiemtraId = 0;
        this.MauphieukiemtraId = 0;
        this.MauphieukiemtraIdNhom = 0;
        this.MauphieukiemtraChitieuId = 0;
        this.TenNhomChiTieu = '';
        this.TenChiTieu = '';
        this.TieuChuan = '';
        this.SoTieuChiTrongNhom = 0;
        this.Ketqua = 'Đạt';
        this.Danhgiaketqua = true;
        this.Diengiai = '';
        this.Thoigiandutru = '';
        this.Danhgiaketquaselect = 0;
    }

    copy(item: PhieuKiemTraPassKhanKetQua){
        this.Id = item.Id;
        this.PhieukiemtraId = item.PhieukiemtraId;
        this.MauphieukiemtraId = item.MauphieukiemtraId;
        this.MauphieukiemtraIdNhom = item.MauphieukiemtraIdNhom;
        this.MauphieukiemtraChitieuId = item.MauphieukiemtraChitieuId;
        this.TenNhomChiTieu = item.TenNhomChiTieu;
        this.TenChiTieu = item.TenChiTieu;
        this.TieuChuan = item.TieuChuan;
        this.SoTieuChiTrongNhom = item.SoTieuChiTrongNhom;
        this.Ketqua = item.Ketqua;
        this.Danhgiaketqua = item.Danhgiaketqua;
        this.Diengiai = item.Diengiai;
        this.Thoigiandutru = item.Thoigiandutru;
        this.Danhgiaketquaselect = item.Danhgiaketquaselect;
    }
}

export class PhieuKiemTraLsPassKhanThaoTac extends BaseModel{
    Id: number;
    PhieudenghiId: number;
    Nguoithaotac: number;
    TenNguoiThaoTac: string;
    Ngaythaotac: string;
    Loaithaotac: string;
    Noidung: string;
    Ghichu: string;
    KetQuaKiemTraChatLuong: string
    YKienDeNghi: string

    clear(){
        this.Id = 0;
        this.PhieudenghiId = 0;
        this.Nguoithaotac = 0;
        this.TenNguoiThaoTac = '';
        this.Ngaythaotac = '';
        this.Loaithaotac = '';
        this.Noidung = '';
        this.Ghichu = '';
        this.KetQuaKiemTraChatLuong = "";
        this.YKienDeNghi = "";
    }

    copy(item: PhieuKiemTraLsPassKhanThaoTac){
        this.Id = item.Id;
        this.PhieudenghiId = item.PhieudenghiId;
        this.Nguoithaotac = item.Nguoithaotac;
        this.TenNguoiThaoTac = item.TenNguoiThaoTac;
        this.Ngaythaotac = item.Ngaythaotac;
        this.Loaithaotac = item.Loaithaotac;
        this.Noidung = item.Noidung;
        this.Ghichu = item.Ghichu;
        this.KetQuaKiemTraChatLuong = item.KetQuaKiemTraChatLuong;
        this.YKienDeNghi = item.YKienDeNghi;
    }
}
